import React from 'react';

import { FieldProps } from '@api';
import { Form } from '@ui-library/form';

import { Select } from '@ui-library/select';
import { RedAsterisk } from '@components/common/redAsterisk';

export const SelectField: React.FC<FieldProps<'selectField'>> = ({ fieldConfig }) => (
  <Form.Item
    name={fieldConfig.key}
    label={[fieldConfig.label, fieldConfig.optional ? '' : <RedAsterisk />]}
    extra={fieldConfig.info}
    rules={[{ required: !fieldConfig.optional }, ...(fieldConfig.rules ?? [])]}
    initialValue={fieldConfig.default}
  >
    <Select
      showSearch
      filterOption={(input, option) =>
        (option?.label as string).toLowerCase().includes(input.toLowerCase())
      }
      options={fieldConfig.options}
      disabled={fieldConfig.disabled}
    />
  </Form.Item>
);
